class OptionEditor {

  $onInit() {
    this.content = this.option.content;
    this.analysis = this.option.analysis;
    this.contentId = this.questionIndex + '_option_content_' + this.optionIndex;
    this.analysisId = this.questionIndex + '_option_analysis_' + this.optionIndex;
  };

  saveContent(content) {
    // console.log("saveContent", content);
    let optionData = angular.copy(this.option);
    optionData.content = content;
    return this.onOptionUpdate({optionIndex: this.optionIndex, optionData: optionData});
  };

  saveAnalysis(content) {
    // console.log("saveAnalysis", content);
    let optionData = angular.copy(this.option);
    optionData.analysis = content;
    return this.onOptionUpdate({optionIndex: this.optionIndex, optionData: optionData});
  };
}

export default {
  name: 'optionEditor',
  obj: {
    controller: OptionEditor,
    templateUrl: 'components/option_editor.html',
    bindings: {
      option: '<',
      optionIndex: '<',
      questionIndex: '<',
      onOptionUpdate: '&'
    }
  },
  deps: []
};